import React, { useEffect } from 'react';
import { Grid, Container, CssBaseline, makeStyles } from '@material-ui/core';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../app/rootReducer';
import { ADD_RECIPE_VIEW } from '../../constants/routes';
import { getRecipeById } from '../../slices/recipeSlice';
import EnhancedAddOrEditRecipeImagesForm from './EnhancedAddOrEditRecipeImagesForm';

interface IAddRecipeImagesProps {}

const AddRecipeImages: React.FC<IAddRecipeImagesProps> = ({}) => {
    const location = useLocation();
  const dispatch = useDispatch();

  const { recipeId } = useParams<{ recipeId: string | undefined }>();
  const { recipe, recipeLoading } = useSelector((state: RootState) => {
    return {
      recipe: state.recipe.recipe,
      recipeLoading: state.recipe.loading,
    };
  }, shallowEqual);
  const isAddStudent = location.pathname === ADD_RECIPE_VIEW ? true : false;
  useEffect(() => {
    if (!isAddStudent && recipeId) {
      dispatch(getRecipeById(recipeId));
    }
    return () => {};
  }, [isAddStudent, recipeId, dispatch]);
  let renderedForm;
  if (!isAddStudent && recipe) {
    const {
        recipeTitle,
        recipeUrl,
        recipeDescription,
        tags,
        preparationTime,
        userId,
    } = recipe;
    renderedForm = (
      <EnhancedAddOrEditRecipeImagesForm
      recipeTitle={recipeTitle}
      recipeUrl={recipeUrl}
      recipeDescription={recipeDescription}
      tags={tags}
      preparationTime={preparationTime}
      //userId={userId}
      
      />
    );
  } else {
    renderedForm = <EnhancedAddOrEditRecipeImagesForm />;
  }

  return (
    <div>
      <Container
        style={{
          paddingLeft: '0.4em',
          paddingRight: '0.4em',
          height: '80vh',
        }}
      >
        {renderedForm}
      </Container>
    </div>
  );
};
export default AddRecipeImages;
